<div class="modal right" id="routesDetail" tabindex="-1" role="dialog" aria-labelledby="routesDetailLabel">
	<div class="modal-dialog" role="document" style="width: 100%;">
		<div class="modal-content" id="print-content" style="display: block; overflow: hidden;">
			<div class="row">
				<div class="col-md-6">
					<div style="display:block;width:100%;height:100vh;">
						<div id="routeMap" style="width:100%;height:100vh;">></div>
					</div>
				</div>
				<div class="col-md-6" id="scrollDiv" style="height: 100vh;overflow: auto;">
					<div class="modal-header hide-print">
						<div class="modal-title">
							<h4 id="routesDetailLabel">Route Details</h4>
						</div>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="resetRoute()">
							<i class="icon-close-circle"></i>
						</button>
					</div>
					<div class="modal-body order-detail-page">
						<div class="loading" ng-if="loadingWork">
							<div id="global_loader" class="glb-ldr-prt">
								<div class="gl-ldr-cld">
									<div class="gl-ldr-ctr">
										<div class="gl-loader"></div>
									</div>
								</div>
							</div>
						</div>
						<ul class="nav nav-tabs nav-justified hide-print" id="tabContent">
							<li class="active"><a target="_self" href="#rtdetails" data-toggle="tab">Details</a></li>
							<li><a target="_self" class="rtstops" href="#rtstops" data-toggle="tab">Stops</span></a></li>
							<li><a target="_self" href="#rtactivity" data-toggle="tab">Activity</a></li>
						</ul>
						<div class="tab-content">
							<div class="tab-pane active" id="rtdetails">
								<div class="modal-body-container">
									<div class="row">
										<div class="col-md-12 mt-4">
											<div class="print-modal-customer">
												<div class="panel mb-10">
													<div class="row">
														<div class="col-md-6">
															<div class="form-group floating">
																<p>
																	<strong class="mb-3">Driver : {{ route.worker ? route.worker.full_name : 'Not Assigned' }}</strong>
																</p>
																
																<select class="selectpicker" 
																	title="By Driver"
																	data-live-search="true"
																	data-selected-text-format="count" 
																	data-language="tr_TR"
																	ng-model="route.worker_id" 
																	ng-disabled="route.status == 1"
																	ng-keyup="$event.keyCode == 13 && refreshData()"
																	data-style="btn-primary">
																	<option 
																		ng-repeat="member in data.workers | orderBy:['status']"
																		data-select-watcher 
																		data-last="{{$last}}" 
																		class="worker-{{member.vehicle}}"
																		ng-selected="member.id == route.worker_id"
																		value="{{member.id}}">
																		{{member.full_name}}
																	</option>
																</select>
															
															</div>

															<div class="form-group floating">
																<a href="#" class="hod-button blue ml10" ng-click="changeWorker()">
																	Assign
																</a>
															</div>
														</div>
														<div class="col-md-6">
															<div class="form-group floating">
																<select ng-model="route.status" 
																	class="form-control"
																	ng-disabled="route.status == 1">
																	<option value="1" ng-selected="route.status == 1">Completed</option>
																	<option value="0" ng-selected="route.status == 0">Created</option>
																</select>
																<label>Route Status</label>
															</div>
															<div class="form-group floating">
																<a href="#" class="hod-button blue ml10" ng-click="changeRouteStatus(route)">
																	Change RT Status
																</a>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6 mt-2">
											<div class="print-modal-customer">
												<div class="panel mb-10">
													<p>
														<strong>Route ID </strong>
														<span>
															{{ route.unique }}
														</span>
													</p>
													<p>
														<strong>Driver </strong>
														<span>
															{{ route.worker ? route.worker.full_name : '-' }}
														</span>
													</p>
													<p>
														<strong>Station</strong>
														<span>
															{{ route.station ? route.station.code : '-' }}
														</span>
													</p>
													<p>
														<strong>Stops</strong>
														<span>
															{{ route.order_count }}
														</span>
													</p>
													<p>
														<strong>Time</strong>
														<span>
															{{ humanizeDuration(route.total_time) }}
														</span>
													</p>
													<p>
														<strong>Weight</strong>
														<span>
															{{ route.weight }} Lbs
														</span>
													</p>
												</div>
											</div>
										</div>
										<div class="col-md-6 mt-2">
											<div class="print-modal-customer">
												<div class="panel mb-10">
													<p>
														<strong>Date</strong>
														<span>
															{{ route.scheduled_start | amDateFormat:'MM/DD/YYYY'}}, 
															{{ route.scheduled_start | amDateFormat:'hh:mm A'}} - {{ route.scheduled_end | amDateFormat:'hh:mm A'}} 
														</span>
													</p>
													<p>
														<strong>Created At</strong>
														<span>
															{{ route.created_at | amDateFormat:'MM/DD/YYYY, hh:mm A'}}
														</span>
													</p>
													<p>
														<strong>Pcs </strong>
														<span>
															{{ route.pieces }}
														</span>
													</p>
													<p>
														<strong>Distance</strong>
														<span>
															{{ route.distance }}
														</span>
													</p>
													<p>
														<strong>Status </strong>
														<span>
															{{ route.status ? 'Completed' : 'Waiting' }}
														</span>
													</p>
													<p ng-if="route.started_date">
														<strong>Started At </strong>
														<span>
															{{ route.started_date | amDateFormat:'MM/DD/YYYY hh:mm A' }}
														</span>
													</p>
													<p ng-if="route.completed_date">
														<strong>Ended At </strong>
														<span>
															{{ route.completed_date | amDateFormat:'MM/DD/YYYY hh:mm A' }}
														</span>
													</p>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<a href="#" class="hod-button blue ml10" ng-click="editRoute(route)">
												Edit
											</a>
										</div>
									</div>
								</div>
							</div>

							<div class="tab-pane" id="rtstops">
								<div class="modal-body-container">
									<div class="row mt-4">
										<div class="col-md-12">
											<a href="#" class="hod-button blue ml10" ng-click="readAll('route', route.id, 'status', route.id)">
												Read All (Verify)
											</a>
											<a href="#" class="hod-button blue ml10" ng-click="readAll('route', route.id, 'order_status', route.id)">
												Read All (Delivery)
											</a>
											<!-- <a href="#" class="hod-button blue ml10" ng-click="editRoute(route)">
												Arrived All
											</a> -->
										</div>
									</div>

									<div id="timeline" class="timeline-single">
										<div class="row">
											<div class="col-sm-12 left-column route-stops">
												<div class="timeline-item" ng-repeat="order in route.orders">
												<!-- <div class="timeline-item" ng-repeat="order in route.orders | orderBy:'newSort'"> -->
													<div class="timeline-icon">
														<div
															class="{{'order-number order-number-'+ ( order.status ? order.status.value : '' )}}"
														>{{ $index+1 }}</div>
													</div>
													<div class="row">
														<div class="col-md-12">
															<!-- <span class="step">
																Step {{ $index + 1 }}
															</span> <br> -->
															<span class="stop-time">
																<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M17.6181 5.968L19.0711 4.515L20.4851 5.929L19.0321 7.382C20.4678 9.17917 21.161 11.4579 20.9691 13.7501C20.7773 16.0424 19.7151 18.1742 18.0005 19.7077C16.286 21.2412 14.0494 22.0601 11.75 21.9961C9.45067 21.9321 7.26307 20.9901 5.63653 19.3635C4.00999 17.737 3.06799 15.5494 3.00398 13.25C2.93997 10.9506 3.75881 8.71402 5.29234 6.99951C6.82587 5.285 8.95767 4.22275 11.2499 4.03092C13.5422 3.83909 15.8209 4.53223 17.6181 5.968ZM12.0001 20C12.9193 20 13.8296 19.8189 14.6788 19.4672C15.5281 19.1154 16.2998 18.5998 16.9498 17.9497C17.5998 17.2997 18.1154 16.5281 18.4672 15.6788C18.819 14.8295 19.0001 13.9193 19.0001 13C19.0001 12.0807 18.819 11.1705 18.4672 10.3212C18.1154 9.47194 17.5998 8.70026 16.9498 8.05025C16.2998 7.40024 15.5281 6.88463 14.6788 6.53284C13.8296 6.18106 12.9193 6 12.0001 6C10.1435 6 8.36307 6.7375 7.05031 8.05025C5.73756 9.36301 5.00006 11.1435 5.00006 13C5.00006 14.8565 5.73756 16.637 7.05031 17.9497C8.36307 19.2625 10.1435 20 12.0001 20ZM11.0001 8H13.0001V14H11.0001V8ZM8.00006 1H16.0001V3H8.00006V1Z" fill="#828C95"/>
																</svg>
																<div ng-if="order.status.value != 'complete' && order.status.value != 'fail'">
																	{{ route.created_at | amDateFormat:'MM/DD/YYYY hh:mm A' }}
																</div>
																<div ng-if="order.status && (order.status.value == 'complete' || order.status.value == 'fail')">
																	{{ order.completed_at | amDateFormat:'MM/DD/YYYY hh:mm A' }}
																</div>
															</span>
															<div class="row">
																<div class="col-md-9">
																	<p class="location-name">
																		{{ order.location.name.split(' ')[0][0] }}{{ order.location.name.split(' ')[1][0] }} <strong>{{ order.location ? order.location.name : '-' }}</strong> -- {{ order.location.address }}, {{ order.location.city }}, {{ order.location.state }} {{ order.location.zipcode }}
																		<br>
																		<strong ng-bind-html="order.unique | highlightText: searchIdTerms" scroll-if="order.unique.indexOf(searchIdTerms) > -1"></strong>
																	</p>
																</div>
																<div class="col-md-3">
																	<a href="orders?order_id={{order.id}}" target="__BLANK" class="hod-button blue pull-right">Go to Order</a>
																</div>
															</div>

															<div class="items mb10">
																<div class="rt-item-name">
																	Order Statuses 
																</div>
																<div class="form-group floating" ng-init="old = order.status">
																	<select ng-model="order.status" class="form-control"
																		ng-change="changeStatus(order, old)"
																		ng-options="item.name for item in steps track by item.id">
																		<option value="">Created</option>
																	</select>
																	<label>Order Status</label>
																</div>
																<div class="form-group floating">
																	<select ng-model="order.arrived" class="form-control"
																		ng-change="changeArrived(order)"
																		ng-options="o.v as o.n for o in [{ n: 'Not Arrived', v: 0 }, { n: 'Arrived', v: 1 }]">
																	</select>
																	<label>Arrived Status</label>
																</div>
															</div>

															<div class="items" ng-repeat="item in order.items_code">
																<div class="rt-item-name">
																	<span ng-bind-html="item.code | highlightText: searchTerms" scroll-if="item.code.indexOf(searchTerms) > -1"></span>
																</div>
																<div class="form-group floating">
																	<select ng-model="item.status" class="form-control"
																		ng-change="changeItem('status', item.code, item.status, item)"
																		ng-options="o.v as o.n for o in [{ n: 'Not Readed', v: false }, { n: 'Readed', v: true }]">
																	</select>
																	<label>Verify Status</label>
																</div>
																<div class="form-group floating">
																	<select ng-model="item.order_status" class="form-control"
																		ng-change="changeItem('order_status', item.code, item.order_status, item)"
																		ng-options="o.v as o.n for o in [{ n: 'Not Readed', v: false }, { n: 'Readed', v: true }]">
																	</select>
																	<label>Delivery Status</label>
																</div>
															</div>
															<div class="items">
																<div class="rt-item-name"></div>
																<a href="#" ng-click="readAll('order', order.id, 'status', route.id)">Read All</a>
																<a href="#" ng-click="readAll('order', order.id, 'order_status', route.id)">Read All</a>
															</div>
														</div>
													</div>
												</div>
												<div class="timeline-item" ng-if="route.orders.length == 0">
													<div class="timeline-icon">
														<span class="fa fa-times"></span>
													</div>
													<div class="panel">
														<div class="panel-body p20 pt10 pb10">
															<div class="row">
																<div class="col-md-12">
																	<span>No Order Found</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="tab-pane" id="rtactivity">
								<div class="modal-body-container">
									<div id="timeline" class="timeline-single">
										<div class="row">
											<div class="col-sm-12 left-column">
												<div class="timeline-item" ng-repeat="log in route.logs | orderBy: 'created_at'">
													<div class="timeline-icon">
														<span></span>
													</div>
													<div class="row">
														<div class="col-md-12">
															<span>Route 
																<strong ng-if="log.transaction == 'assign_to_worker'"> Assing To Driver</strong>
																<strong ng-if="log.transaction == 'completed'"> Completed</strong>
																<strong ng-if="log.transaction == 'created'"> Created</strong>
																<strong ng-if="log.transaction == 'started'"> Started</strong>
																<strong>{{ log.user.full_name }}</strong>
															</span>
															<br />
															<small>
																{{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
																{{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
															</small>
														</div>		
													</div>
												</div>
												<div class="timeline-item" ng-if="selectedWork.logs.length == 0">
													<div class="timeline-icon">
														<span class="fa fa-times"></span>
													</div>
													<div class="panel">
														<div class="panel-body p20 pt10 pb10">
															<div class="row">
																<div class="col-md-12">
																	<span>No Activity Found</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>